export default {
    en:{
        ' de ':' from ',
        ' portant la réf. ':' with reference ',
        ' vient de valider l’ordre de mission ':' has just validated the Task order ',
        ' vient de s\'inscrire sur la plateformes': ' has just registered on the platform',
        'L\'entreprise ': 'The company ',
        'Demande de validation  ': 'Validation request  ',
        ' de l\'expert ': ' from the expert ',
        'Demande de validation ': 'Validation request ',
        ' vient de signer son contrat': ' has just signed their contract',
        ' vient de signer son attestation sur l’honneur': ' has just signed their declaration of honor',
        'Un rendez-vous pour un entretien avec ': 'An appointment for an interview with ',
        ' le ': ' on ',
        ' à ': ' at ',
        ' a été planifié par ': ' has been scheduled by ',
        'Votre rendez avec ': 'Your appointment with ',
        ' et le client ': ' and the client ',
        ' a été annulé.': ' has been canceled.',
        ' a été rejeté.': ' has been rejected.',
        ' a été replanifié pour le ': ' has been rescheduled for ',
        'La candidature de ': 'The application of ',
        ' pour ': ' for ',
        ' a été retenue par le client ': ' has been accepted by the client ',
        ' vient de rejeter l’ordre de mission ': ' has just rejected the Task order ',
        ' pour cause: ': ' for the reason: ',
        ' vient de rejeter la Proposition commerciale ': ' has just rejected the commercial proposal ',
        ' vient de rejeter vient de rejeter le CRA ': ' has just rejected the timesheet ',
        ' vient de demander l’interruption de la mission ': ' has just requested the interruption of the assignment ',
        'Veuillez relancer le client et l’expert pour renouvellement du BDC ': 'Please follow up with the client and the expert for the renewal of the PO ',
        'Félicitations! Votre mission ': 'Congratulations! Your Assignment ',
        ' vient d\'être créée.': ' has just been created.',
        'Félicitations! Votre candidature vient d’être choisie par notre client': 'Congratulations! Your application has just been chosen by our client',
        ' pour le besoin ': ' for the need ',
        ' a été validé': ' has been validated',
        'Votre document administratif ': 'Your administrative document ',
        ' a été rejeté, veuillez mettre à jour vos informations': ' has been rejected, please update your information',
        'L’ordre de mission de la mission ': 'The Task order of the assignment ',
        ' a été modifié. Veuillez le valider.': ' has been modified. Please validate it.',
        ' arrive à son terme\n Veuillez en télécharger un à jour': ' is coming to an end\n Please download an updated one',
        'La validité de votre ': 'The validity of your ',
        ' n’est plus valide!': ' is no longer valid!',
        'Votre ': 'Your ',
        'Votre candidature pour l’AO ': 'Your application for the AO ',
        ' a été marqué comme \'intéressante\'': ' has been marked as \'interesting\'',
        'Malheureusement, votre candidature à l’AO ': 'Unfortunately, your application for the AO ',
        ' n’a pas été retenue pour le motif ': ' was not retained for the reason ',
        'Un RDV a été planifié pour un entretien le ': 'An appointment has been scheduled for an interview on ',
        'Votre prochain entretien est planifié pour le ': 'Your next interview is scheduled for ',
        'Votre bon de commande de la mission ': 'Your Task order form ',
        ' a été généré': ' has been generated',
        ' a été renouvelé': ' has been renewed',
        ' a été interrompue par le client,. La date effective de l’interruption est le ':'was interrupted by the client. The effective date of the interruption is',
        'Le bon de Commande de la mission ': 'The order form for the assignment ',
        'Nous vous informons de l’annulation de la mission ': 'We inform you of the cancellation of the assignment ',
        'Votre demande d’interruption de la mission ': 'Your request for interruption of the assignment ',
        ' a été validée par l’équipe HTH. La date effective de l’interruption est le ': ' was validated by the HTH team. The effective date of the interruption is ',
        'La date effective de l’interruption est le ': 'The effective date of the interruption is ',
        ' a été rejetée pour cause ': ' has been rejected for the reason ',
        ' Avis d’interruption de mission ': ' Notice of assignment interruption ',
        ' a été interrompue par le client,. ': ' has been interrupted by the client,. ',
        'Votre Compte Rendu d’Activité de la prestation complémentaire du mois ': 'Your Timesheet (TS)/propal of the additional service for the month ',
        'Votre Compte Rendu d’Activité du mois ': 'Your Timesheet (TS)/propal for the month ',
        ' a été validé par le client': ' has been validated by the client',
        ' est rejeté par le client pour cause: ': ' has been rejected by the client for the reason: ',
        'La facture de la période ': 'The invoice for the period ',
        ' liée au CRA ': ' linked to the Timesheet ',
        ' est générée!': ' has been generated!',
        'La régularisation de la période ': 'The adjustment for the period ',
        'Un avoir de la période ': 'A credit for the period ',
        ' lié au CRA ': ' linked to the timesheet ',
        ' est généré!': ' has been generated!',
        ' de la période ': ' of the period ',
        'La facture ': 'The invoice ',
        ' est payée!': ' is paid!',
        'La régularisation ': 'The adjustment ',
        'Veuillez valider votre Compte Rendu d’activité ': 'Please validate your Timesheet (TS)/propal ',
        ' du mois ': ' for the month ',
        ' a été rejeté. Veuillez corriger et mettre à jour vos informations': ' has been rejected. Please correct and update your information',
        ' demande de rejoindre votre entreprise': ' requests to join your company',
        'Demande de rejoindre ': 'Request to join ',
        ' sur HTH est acceptée': ' on HTH has been accepted',
        'Votre demande de rendez-vous pour un entretien avec l’expert ': 'Your request for an appointment with the expert ',
        ' a été acceptée': ' has been accepted',
        'Votre demande de rendez-vous pour un entretien avec l\'expert ': 'Your request for an appointment with the expert ',
        ' a été replanifiée pour le ': ' has been rescheduled for ',
        'Veuillez valider la proposition commerciale liée à la nouvelle mission ': 'Please validate the commercial proposal related to the new assignment ',
        'La proposition commerciale pour la mission ': 'The commercial proposal for the assignment ',
        ' a été modifiée, veuillez la valider.': ' has been modified, please validate it.',
        'Votre BDC lié à la mission ': 'Your PO related to the assignment ',
        ' a été automatiquement généré et validé.': ' has been automatically generated and validated.',
        'Veuillez valider le Compte Rendu d’activité du mois ': 'Please validate the Timesheet (TS)/propal for the month ',
        'Avis d’interruption de mission ': 'Notice of assignment interruption ',
        ' a été interrompue par l\'expert.La date effective de l’interruption est le ': ' has been interrupted by the expert. The effective date of the interruption is ',
        'L\'avoir ': 'The credit note ',
        ' est payé!': ' has been paid!',
        'Le document administratif ':'The administrative document ',
        ' a expiré le ':' expired on ',
        ', l’équipe High Tech Hires vous souhaite la bienvenue et vous invite à compléter votre profil':', the High Tech Hires team welcomes you and invites you to complete your profile',
        ', l’équipe High Tech Hires vous souhaite la bienvenue !':', the High Tech Hires team welcomes you!',
        ' à High Tech Hires!':' to High Tech Hires!',
        //notification traduction
        'Veuillez compléter/vérifier les informations société' : 'Please complete/check the company information',
        'Veuillez vérifier tous vos documents administratifs' : 'Please check all your administrative documents',
        'Veuillez valider votre ordre de mission' : 'Please validate your Task order',
        'Votre Kbis est validé avec succès et votre compte est désormais activé!' : 'Your Kbis has been successfully validated and your account is now activated!',
        'Ce lien n\'est plus valide, demandez à votre Admin' : 'This link is no longer valid, please ask your Admin',
        'la date du paiement est un champ requis' : 'the payment date is a required field',
        'Une erreur s\'est produite lors du traitement de la demande.' : 'An error occurred while processing the request.',
        'Veuillez compléter les champs obligatoires manquants' : 'Please complete the missing required fields',
        'la référence est un champ requis' : 'the reference is a required field',
        'Toutes les factures doivent avoir le statut proforma' : 'All invoices must have proforma status',
        'Veuillez respecter la taille maximale du fichier (2Mo)' : 'Please respect the maximum file size (2MB)',
        'Laissez-nous vos coordonnées pour que notre équipe puisse vous contacter':'Leave us your contact details so our team can reach you',
        'Type de demande':'Request type',
        'En cliquant sur "Envoyer", j\'accepte les':'By clicking "Send", I accept the',
        'conditions générales':'terms and conditions',
        'd\'utilisation':'of use',
        'de High Tech Hires, y compris l\'accord d\'utilisation et la':'of High Tech Hires, including the user agreement and the',
        ' vient de valider la Proposition commerciale ':' has just validated the commercial proposal ',
        'Demande de validation “Kbis” de ':'Validation request for “Kbis” from ',
    },
    fr:{
        'Demande de validation “Kbis” de ':'Demande de validation “Kbis” de ',
        ' vient de valider la Proposition commerciale ':' vient de valider la Proposition commerciale ',

        ' de ':' de ',
        ' portant la réf. ':' portant la réf. ',
        ' vient de valider l’ordre de mission ':' vient de valider l’ordre de mission ',
        ' vient de s\'inscrire sur la plateformes':' vient de s\'inscrire sur la plateformes',
        'L\'entreprise ':'L\'entreprise ',
        'Demande de validation  ':'Demande de validation  ',
        ' de l\'expert ':' de l\'expert ',
        'Demande de validation ':'Demande de validation ',
        ' vient de signer son contrat':' vient de signer son contrat',
        ' vient de signer son attestation sur l’honneur':' vient de signer son attestation sur l’honneur',
        'Un rendez-vous pour un entretien avec ':'Un rendez-vous pour un entretien avec ',
        ' le ':' le ',
        ' à ':' à ',
        ' a été interrompue par le client,. La date effective de l’interruption est le ':' a été interrompue par le client,. La date effective de l’interruption est le ',
        ' a été planifié par ':' a été planifié par ',
        'Votre rendez avec ':'Votre rendez avec ',
        ' et le client ':' et le client ',
        ' a été annulé.':' a été annulé.',
        ' a été rejeté.':' a été rejeté.',
        ' a été replanifié pour le ':' a été replanifié pour le ',
        'La candidature de ':'La candidature de ',
        ' pour ':' pour ',
        ' a été retenue par le client ':' a été retenue par le client ',
        ' vient de rejeter l’ordre de mission ':' vient de rejeter l’ordre de mission ',
        ' pour cause: ':' pour cause: ',
        ' vient de rejeter la Proposition commerciale ':' vient de rejeter la Proposition commerciale ',
        ' vient de rejeter vient de rejeter le CRA ':' vient de rejeter vient de rejeter le CRA ',
        ' vient de demander l’interruption de la mission ':' vient de demander l’interruption de la mission ',
        'Veuillez relancer le client et l’expert pour renouvellement du BDC ':'Veuillez relancer le client et l’expert pour renouvellement du BDC ',
        'Félicitations! Votre mission ':'Félicitations! Votre mission ',
        ' vient d\'être créée.':' vient d\'être créée.',
        'Félicitations! Votre candidature vient d’être choisie par notre client':'Félicitations! Votre candidature vient d’être choisie par notre client',
        ' pour le besoin ':' pour le besoin ',
        ' a été validé':' a été validé',
        'Votre document administratif ':'Votre document administratif ',
        ' a été rejeté, veuillez mettre à jour vos informations':' a été rejeté, veuillez mettre à jour vos informations',
        'L’ordre de mission de la mission ':'L’ordre de mission de la mission ',
        ' a été modifié. Veuillez le valider.':' a été modifié. Veuillez le valider.',
        ' arrive à son terme\n Veuillez en télécharger un à jour':' arrive à son terme\n Veuillez en télécharger un à jour',
        'La validité de votre ':'La validité de votre ',
        ' n’est plus valide!':' n’est plus valide!',
        'Votre ':'Votre ',
        'Votre candidature pour l’AO ':'Votre candidature pour l’AO ',
        ' a été marqué comme "intéressante"':' a été marqué comme "intéressante"',
        'Malheureusement, votre candidature à l’AO ':'Malheureusement, votre candidature à l’AO ',
        ' n’a pas été retenue pour le motif ':' n’a pas été retenue pour le motif ',
        'Un RDV a été planifié pour un entretien le ':'Un RDV a été planifié pour un entretien le ',
        'Votre prochain entretien est planifié pour le ':'Votre prochain entretien est planifié pour le ',
        'Votre bon de commande de la mission ':'Votre bon de commande de la mission ',
        ' a été généré':' a été généré',
        ' a été renouvelé':' a été renouvelé',
        'Le bon de Commande de la mission ':'Le bon de Commande de la mission ',
        'Nous vous informons de l’annulation de la mission ':'Nous vous informons de l’annulation de la mission ',
        'Votre demande d’interruption de la mission ':'Votre demande d’interruption de la mission ',
        ' a été validée par l’équipe HTH. La date effective de l’interruption est le ':' a été validée par l’équipe HTH. La date effective de l’interruption est le ',
        'La date effective de l’interruption est le ':'La date effective de l’interruption est le ',
        ' a été rejetée pour cause ':' a été rejetée pour cause ',
        ' Avis d’interruption de mission ':' Avis d’interruption de mission ',
        ' a été interrompue par le client,. ':' a été interrompue par le client,. ',
        'Votre Compte Rendu d’Activité de la prestation complémentaire du mois ':'Votre Compte Rendu d’Activité de la prestation complémentaire du mois ',
        'Votre Compte Rendu d’Activité du mois ':'Votre Compte Rendu d’Activité du mois ',
        ' a été validé par le client':' a été validé par le client',
        ' est rejeté par le client pour cause: ':' est rejeté par le client pour cause: ',
        'La facture de la période ':'La facture de la période ',
        ' liée au CRA ':' liée au CRA ',
        ' est générée!':' est générée!',
        'La régularisation de la période ':'La régularisation de la période ',
        'Un avoir de la période ':'Un avoir de la période ',
        ' lié au CRA ':' lié au CRA ',
        ' est généré!':' est généré!',
        ' de la période ':' de la période ',
        'La facture ':'La facture ',
        ' est payée!':' est payée!',
        'La régularisation ':'La régularisation ',
        'Veuillez valider votre Compte Rendu d’activité ':'Veuillez valider votre Compte Rendu d’activité ',
        ' du mois ':' du mois ',
        ' a été rejeté. Veuillez corriger et mettre à jour vos informations':' a été rejeté. Veuillez corriger et mettre à jour vos informations',
        ' demande de rejoindre votre entreprise':' demande de rejoindre votre entreprise',
        'Demande de rejoindre ':'Demande de rejoindre ',
        ' sur HTH est acceptée':' sur HTH est acceptée',
        'Votre demande de rendez-vous pour un entretien avec l’expert ':'Votre demande de rendez-vous pour un entretien avec l’expert ',
        ' a été acceptée':' a été acceptée',
        'Votre demande de rendez-vous pour un entretien avec l\'expert ':'Votre demande de rendez-vous pour un entretien avec l\'expert ',
        ' a été replanifiée pour le ':' a été replanifiée pour le ',
        'Veuillez valider la proposition commerciale liée à la nouvelle mission ':'Veuillez valider la proposition commerciale liée à la nouvelle mission ',
        'La proposition commerciale pour la mission ':'La proposition commerciale pour la mission ',
        ' a été modifiée, veuillez la valider.':' a été modifiée, veuillez la valider.',
        'Votre BDC lié à la mission ':'Votre BDC lié à la mission ',
        ' a été automatiquement généré et validé.':' a été automatiquement généré et validé.',
        'Veuillez valider le Compte Rendu d’activité du mois ':'Veuillez valider le Compte Rendu d’activité du mois ',

        'Avis d’interruption de mission ':'Avis d’interruption de mission ',
        ' a été interrompue par l\'expert.La date effective de l’interruption est le ':' a été interrompue par l\'expert.La date effective de l’interruption est le ',
        'L\'avoir ':'L\'avoir ',
        ' est payé!':' est payé!',
        'Le document administratif ':'Le document administratif ',
        ' a expiré le ':' a expiré le ',
        ', l’équipe High Tech Hires vous souhaite la bienvenue et vous invite à compléter votre profil':', l’équipe High Tech Hires vous souhaite la bienvenue et vous invite à compléter votre profil',
        ', l’équipe High Tech Hires vous souhaite la bienvenue !':', l’équipe High Tech Hires vous souhaite la bienvenue !',
        ' à High Tech Hires!':' à High Tech Hires!',
        //notification traduction
        'Veuillez compléter/vérifier les informations société':'Veuillez compléter/vérifier les informations société',
        'Veuillez vérifier tous vos documents administratifs':'Veuillez vérifier tous vos documents administratifs',
        'Veuillez valider votre ordre de mission':'Veuillez valider votre ordre de mission',
        'Votre Kbis est validé avec succès et votre compte est désormais activé!': 'Votre Kbis est validé avec succès et votre compte est désormais activé!',
        'Ce lien n\'est plus valide, demandez à votre Admin':'Ce lien n\'est plus valide, demandez à votre Admin',
        'la date du paiement est un champs requis':'la date du paiement est un champs requis',
        'Une erreur s\'est produite lors du traitement de la demande.':'Une erreur s\'est produite lors du traitement de la demande.',
        'Veuillez compléter les champs obligatoires manquants':'Veuillez compléter les champs obligatoires manquants',
        'la référence est un champs requis':'la référence est un champs requis',
        'Toutes les factures doivent avoir le statut proforma':'Toutes les factures doivent avoir le statut proforma',
        'Veuillez respecter la taille maximale du fichier (2Mo)':'Veuillez respecter la taille maximale du fichier (2Mo)',

        'Laissez-nous vos coordonnées pour que notre équipe puisse vous contacter':'Laissez-nous vos coordonnées pour que notre équipe puisse vous contacter',
        'Type de demande':'Type de demande',
        'En cliquant sur "Envoyer", j\'accepte les':'En cliquant sur "Envoyer", j\'accepte les',
        'conditions générales':'conditions générales',
        'd\'utilisation':'d\'utilisation',
        'de High Tech Hires, y compris l\'accord d\'utilisation et la':'de High Tech Hires, y compris l\'accord d\'utilisation et la',

    },

};